module.exports = __webpack_public_path__ + "static/media/Subtract-1.5ddc1350.svg";